import { render, staticRenderFns } from "./camparePeriod.vue?vue&type=template&id=b5c5f8ae"
import script from "./camparePeriod.vue?vue&type=script&lang=js"
export * from "./camparePeriod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports